import { FC } from 'react';
import { type CourseHearing } from '@teachur/http-client';
import { CourseHearingSubmissionsHistorySidePanel } from './CourseHearingSubmissionsHistorySidePanel';

interface CourseHearingDrawerSidePanelProps {
  call: CourseHearing | null;
  isSubmissionsHistoryOpen: boolean;
  onCloseSubmissionsHistory: () => void;
}

export const CourseHearingDrawerSidePanel: FC<CourseHearingDrawerSidePanelProps> = ({
  call,
  isSubmissionsHistoryOpen,
  onCloseSubmissionsHistory,
}) => {
  if (isSubmissionsHistoryOpen) {
    return (
      <CourseHearingSubmissionsHistorySidePanel call={call} onClose={onCloseSubmissionsHistory} />
    );
  }

  return null;
};
